import React, { Component } from 'react'
import {
    withRouter
} from 'react-router-dom'
import { Container, Row, Col, Button, ProgressBar } from 'react-bootstrap'
import 'core-js';
import _ from 'lodash'
import moment from 'moment'
import numberHelpers from '../helpers/NumberHelpers'
import styleHelpers from '../helpers/StyleHelpers'

import Page from './Page'
import '../styles/global.css'
import CheckTickets from '../containers/CheckTicketsContainer'
import V2EventPage from './v2/V2EventPage'
import V2NotFoundPage from './v2/V2NotFoundPage'
import V2AccessCodePage from './v2/V2AccessCodePage'
import { storeEventAccessCode } from '../store/api'

const TIMER = 10

function logoFrameClass(frame) {
    if (frame === 'circle') return 'logoFrame logoFrame-circle'
    if (frame === 'rounded') return 'logoFrame logoFrame-rounded'
    if (frame === 'square') return 'logoFrame logoFrame-square'
    return 'logoFrame'
}

function logoImageStyle(styles) {
    const source = styles || {}
    return {
        transform: 'translate(' + ((Number(source.logoOffsetX || 0) * 100).toFixed(3)) + '%, ' + ((Number(source.logoOffsetY || 0) * 100).toFixed(3)) + '%) scale(' + Number(source.logoScale || 1) + ')',
        transformOrigin: 'center center'
    }
}

function skinClass(styles) {
    const skin = styles && styles.skin ? styles.skin : 'classic'
    if (skin === 'spotlight') return 'publicSkin publicSkin--spotlight'
    return 'publicSkin publicSkin--classic'
}

function isSpotlightSkin(styles) {
    return styles && styles.skin === 'spotlight'
}

class Dashboard extends Page {

    state = {
        fetchingEvent: false,
        hasEvent: false,
        showCheckTickets: false,
        refreshingEvent: false,
        timer: 0
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        let self = this
        this._closeCheckTickets = this._closeCheckTickets.bind(this)
        this._refreshEvent = this._refreshEvent.bind(this)

        if (!self.props.client || !self.props.event) {
            self.setState({ fetchingEvent: true }, () => {
                self.props.fetchEvent(self.props.location.pathname, (hasEvent) => {
                    self._eventReady(hasEvent)
                })
            })
        } else {
            self.setState({ timer: 10 }, () => {
                self._eventReady(true)
            })

        }
    }

    componentWillUnmount() {
        if (this._interval) clearInterval(this._interval);
    }

    _eventReady(hasEvent) {
        let self = this
        self.setState({ hasEvent: hasEvent, fetchingEvent: false })
        this._interval = setInterval(this._refreshEvent, 1000);

    }

    _refreshEvent() {
        if (this.state.refreshingEvent || this.state.fetchingEvent) return
        this.setState({ timer: this.state.timer + 1 })
        if (this.state.timer >= TIMER) {

            let self = this
            self.setState({ refreshingEvent: true, timer: 0 }, () => {
                self.props.fetchEvent(self.props.location.pathname, (hasEvent) => {
                    self.setState({ hasEvent: hasEvent, refreshingEvent: false })
                })
            })
        }
    }

    _closeCheckTickets() {
        this.setState({ showCheckTickets: false })
    }



    render() {
        let self = this
        const spotlightSkin = isSpotlightSkin(this.props.client && this.props.client.styles)

        if (self.props.location.pathname == "/") {
            return <V2NotFoundPage />
        }

        if (self.state.fetchingEvent) {
            return (
                <div className="public-event-loading">
                    <div className="public-event-loader">
                        <img src="/resources/s50.png" alt="" />
                    </div>
                </div>
            )
        }

        if (!self.state.hasEvent || !this.props.client || !this.props.event) {
            return <V2NotFoundPage />
        }

        if (this.props.event && this.props.event.v2) {
            if (this.props.event.locked) {
                return (
                    <V2AccessCodePage
                        client={this.props.client}
                        event={this.props.event}
                        onUnlock={(code, done) => {
                            storeEventAccessCode(this.props.location.pathname, code)
                            this.props.fetchEvent(this.props.location.pathname, (hasEvent) => {
                                done(hasEvent === true)
                            })
                        }}
                    />
                )
            }
            return <V2EventPage client={this.props.client} event={this.props.event} />
        }

        styleHelpers.applyStyles(this.props.client.styles)

        let content = null
        if (self.props.event.completed) {
            content =
                <div className={skinClass(this.props.client.styles)}>
                    <div className="backgroundImage">
                        {this.props.client.styles.hero ? <div className="hero"><img src={this.props.client.styles.hero} alt="hero" /></div> : null}
                        <div className="backgroundOverlay" />
                        <Container className="contentContainer">

                            <CheckTickets
                                show={this.state.showCheckTickets}
                                onHide={this._closeCheckTickets}
                                eventId={this.props.event.SK}
                                eventSource="legacy" />


                            <div className="mx-auto content">
                                <div className={logoFrameClass(this.props.client.styles.logoFrame)} style={this.props.client.styles.logoBg ? { background: this.props.client.styles.logoBg } : null}>
                                    <img src={this.props.client.styles.logo} className="logo" alt="logo" style={logoImageStyle(this.props.client.styles)} />
                                </div>
                                <div id="chevron">
                                    Final Prize Pool
                                </div>
                                <div id="prizepool">
                                    <span>${this.props.event.prizePool.toFixed(2)}</span>
                                </div>
                                <div id="event_no">
                                    <span>EVENT #{this.props.event.SK}</span>
                                    {
                                        this.props.event.license ?
                                            <>
                                                <br />
                                                <span>{this.props.event.license}</span>
                                            </>
                                            : null
                                    }
                                </div>
                                {this.props.event.completeBeforeDraw ?
                                    <div>
                                        <h4 className="txt-red">{this.props.event.completedAltText || "This event has now completed."}</h4>
                                        {this.props.event.winningTicket != "-" ?
                                        <p>The winning ticket was {this.props.event.SK}_{numberHelpers.pad(this.props.event.winningTicket, 3)}</p>
                                            : null}
                                    </div>
                                    :
                                    <div>
                                        <h4 className="txt-red">This event has now completed and was drawn on {moment(this.props.event.endDate).format("DD/MM/YY")} at {moment(this.props.event.endDate).format("h:mma")}</h4>
                                        {this.props.event.winningTicket != "-" ?
                                            <p>The winning ticket was {this.props.event.SK}_{numberHelpers.pad(this.props.event.winningTicket, 3)}</p>
                                            : null}

                                        <Button onClick={() => self.setState({ showCheckTickets: true })} className="btn btn-secondary mt-4">Check my Ticket</Button>
                                        <Button onClick={() => self._nagivateToPage("/" + this.props.client.stub + "/events")} className="btn btn-secondary mt-3">Past Events</Button>
                                    </div>
                                }
                            </div>

                        </Container>

                    </div>
                </div>
        } else if (self.props.event.pending) {
            return (
                <Container>
                    <p className="txt-gld text-center">This event has not started</p>
                </Container>
            )
        } else {
            content = <div className={skinClass(this.props.client.styles)}>

                <div className="backgroundImage">
                    {this.props.client.styles.hero ? <div className="hero"><img src={this.props.client.styles.hero} alt="hero" /></div> : null}
                    <div className="backgroundOverlay" />
                    <Row>
                        <Col md={12}>
                            <ProgressBar min={0} max={TIMER - 1} now={this.state.timer} />
                        </Col>
                    </Row>

                    <Container className="contentContainer">

                        <CheckTickets
                            show={this.state.showCheckTickets}
                            onHide={this._closeCheckTickets}
                            eventId={this.props.event.SK}
                            eventSource="legacy" />


                        <div className="mx-auto content">
                            <div className={logoFrameClass(this.props.client.styles.logoFrame)} style={this.props.client.styles.logoBg ? { background: this.props.client.styles.logoBg } : null}>
                                <img src={this.props.client.styles.logo} className="logo" alt="logo" style={logoImageStyle(this.props.client.styles)} />
                            </div>
                            {this.props.event.title ?
                                <h4 className="txt-red" style={{ marginTop: 32, marginBottom: 30 }}>{this.props.event.title}</h4>
                                : null}
                            <div id="chevron">
                                Live Prize Pool
                            </div>
                            <div id="prizepool">
                                <span>${this.props.event.prizePool.toFixed(2)}</span>
                            </div>
                            <div id="event_no">
                                <span>EVENT #{this.props.event.SK}</span>
                                {
                                    this.props.event.license ?
                                        <>
                                            <br />
                                            <span>{this.props.event.license}</span>
                                        </>
                                        : null
                                }
                            </div>
                            {this.props.event.drawPending ?
                                <h4 className="txt-red">{this.props.event.completedAltText || "This event has now completed and is awaiting the winner draw."}</h4>
                                :
                                this.props.event.altDrawMsg ?
                                    <h4 className="txt-red">{this.props.event.altDrawMsg}</h4>
                                :
                                <h4 className="txt-red">Winner drawn when prize pool reaches ${this.props.event.maxPrizePool}{this.props.event.drawDate && this.props.event.drawDate != "" ? " OR ON " + moment(new Date(this.props.event.drawDate)).format("DD/MM/YY") + " AFTER " + moment(new Date(this.props.event.drawDate)).format("h:mma") : ""}</h4>
                            }
                            {this.props.client.altPromo ? <p>{this.props.client.altPromo}</p> : <p>Buy a ticket to support {this.props.client.charity} and for your chance to win 50% of the final prize pool.</p>}
                            {spotlightSkin ?
                                <div className="spotlightSplitBar mb-5">
                                    <div className="box spotlightSplitBar__panel spotlightSplitBar__panel--winner">
                                        <h4>winner</h4>
                                        <span>${(Number(this.props.event.prizePool) / 2).toFixed(2)}</span>
                                    </div>
                                    <div className="box spotlightSplitBar__panel spotlightSplitBar__panel--charity">
                                        <h4>{this.props.client.charityAlt ? this.props.client.charityAlt : this.props.client.charity}</h4>
                                        <span>${(Number(this.props.event.prizePool) / 2).toFixed(2)}</span>
                                    </div>
                                </div>
                                :
                                <>
                                    <div className="box">
                                        <h4>winner</h4>
                                        <span>${(Number(this.props.event.prizePool) / 2).toFixed(2)}</span>
                                    </div>
                                    <div className="box box-charity-invert mb-5">
                                        <h4>{this.props.client.charityAlt ? this.props.client.charityAlt : this.props.client.charity}</h4>
                                        <span>${(Number(this.props.event.prizePool) / 2).toFixed(2)}</span>
                                    </div>
                                </>}
                            {!this.props.event.drawPending ?
                                <Button onClick={() => self._nagivateToPage("/" + this.props.client.stub + "/buy")} className="btn btn-primary btn-block mb-4">Buy Tickets</Button>
                                : null}
                            <Button onClick={() => self.setState({ showCheckTickets: true })} className="btn btn-secondary mt-4">Check my Ticket</Button>
                            <Button onClick={() => self._nagivateToPage("/" + this.props.client.stub + "/events")} className="btn btn-secondary mt-3">Past Events</Button>

                        </div>

                    </Container>

                </div>

            </div>
        }

        return (
            content
        )
    }
}

export default withRouter(Dashboard)        
